













import { Component, Prop, Vue } from 'vue-property-decorator';
import FooterDisclaimer from './footer-disclaimer.vue';

@Component({
	components: {
		FooterDisclaimer
	}
})
export default class FooterBasic extends Vue {
	@Prop({ default: true })
	addContainerClass!: boolean;
}
